export default __webpack_public_path__ + "static/media/set_7_Link-6.19b4b929.svg";